export enum RequestMethodEnum {
  GET = 'GET',
  POST = 'POST',
  DELETE = 'DELETE',
  PATCH = 'PATCH',
  PUT = 'PUT',
}

export enum HttpStatus {
  OK = 200,
  CREATED = 201,
  NO_CONTENT = 204,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  UNPROCESSABLE_ENTITY = 422,
  INTERNAL_SERVER_ERROR = 500,
}

export interface ApiError {
  message: string;
  status: number;
  code?: string;
}

export interface ApiResponse<T> {
  data?: T;
  message?: string;
  success?: boolean;
  errors?: ApiError[];
}

export enum SyncthingFolderTypeEnum {
  COMMON = 'COMMON',
  INSTANCE = 'INSTANCE',
  BRANDING = 'BRANDING',
  INTERACTION = 'INTERACTION',
}

export enum SyncthingSyncTypeEnum {
  sendreceive = 'sendreceive',
  receiveonly = 'receiveonly',
  sendonly = 'sendonly',
}

export type SyncthingFolder = {
  id: number;
  type: SyncthingFolderTypeEnum;
  folder_id: string;
  label: string;
  path: string;
  sync_type: SyncthingSyncTypeEnum;
  created_at: string;
  updated_at: string;
};
